export interface AttributesModalPosition {
  readonly x: number;
  readonly y: number;
}

/**
 * Clamp the Attributes panel X position between the navbar and right sidebar.
 */
export function clampAttributesModalPositionX(
  x: number,
  minX: number,
  maxX: number,
): number {
  if (!Number.isFinite(x)) {
    return Number.isFinite(minX) ? minX : 0;
  }
  if (Number.isFinite(maxX) && x > maxX) {
    return maxX;
  }
  if (Number.isFinite(minX) && x < minX) {
    return minX;
  }
  return x;
}

export function readInitialAttributesModalPosition(): AttributesModalPosition {
  const navbar = document.querySelector(
    '.xa-navbar.expanded, .xa-navbar.collapsed',
  ) as HTMLElement | null;
  return {
    x: navbar?.offsetWidth ?? 0,
    y: 0,
  };
}
